import React from 'react'
import useIsStationPassportDonationEnabled from '../../../../shared/providers/FeatureTogglesProvider/useIsStationPassportDonationEnabled'
import PassPortUpsellTS from './PassPortUpsellTS'
import PassPortUpsellScreen from './PassPortUpsellScreen'

/**
 * Route wrapper for /passport-upsell/:callsign.
 *
 * Single hook-point for the `is-station-passport-donation-enabled` feature flag.
 * When the flag is OFF (default), renders the current migrated PassPortUpsell screen.
 * When the flag is ON, renders the new PassPortUpsellScreen (to be replaced
 * with the actual new experience in a subsequent slice — OTTERGA-2594).
 *
 * This wrapper replaces the direct PassPortUpsell mount in App.js so that
 * flag-based routing stays in one testable place.
 */
function PassPortUpsellWrapper() {
  const { isStationPassportDonationEnabled, isLoading } =
    useIsStationPassportDonationEnabled()

  if (isLoading) {
    return null
  }

  if (isStationPassportDonationEnabled) {
    return <PassPortUpsellScreen />
  }

  return <PassPortUpsellTS />
}

export default PassPortUpsellWrapper
